(function ($) {
    $(document).ready(function () {
        var comparisionList = [];
        var maxItemsToCompare = 0;
        var clientWidth = window.innerWidth;
        if (clientWidth <= 767)
            maxItemsToCompare = 2;
        else if (768 <= clientWidth && clientWidth <= 991)
            maxItemsToCompare = 3;
        else
            maxItemsToCompare = 4;
        var serviceUrl = "";
        var type = "GET";
        var data = {};
        var configSettings = $(".product-container").attr("data-app-config");
        if (configSettings) {
            configSettings = JSON.parse(configSettings);
        }
        if (configSettings && !configSettings.enableCompare) {
            $(".compareProductsButton,.starRatingComponent").empty().remove();
        }
        var successCallback = function (response) {

            response.url = "";
            response.productBenefitStatement = "[Product Benefit Statement]";
            response.productId = "product-id-1";
            $("[id='" + response.productId + "'] .product-list-icon img").attr("src", response.url);
            $("[id='" + response.productId + "'] .product-list-benefit-statement p").text(response.productBenefitStatement);
        };
        var tiles = $(".productDetail-tile");
        for (var i = 0; i < tiles.length; i++) {

            var productId = $(tiles[i]).attr("id");
            if ($("[id='" + productId + "'] .product-list-icon img").attr("src") === "") {
                getMethod(serviceUrl, type, data, successCallback);
            }

        }

        $("body").on("click", ".btn-compare", function (evt) {

            var currentItem = {
                "id": $(this).parents(".productDetail-tile").attr("id"),
                "href": $(this).parents(".productDetail-tile").find('[data-bv-show="inline_rating"]').attr("data-bv-redirect-url")
            };
            var itemAlreadyExists = false;
            for (var i = 0; i < comparisionList.length; i++) {
                if (comparisionList[i].id === $(this).parents(".productDetail-tile").attr("id")) {
                    itemAlreadyExists = true;
                }
            }
            $(".product-compare-flyout").css("display", "flex");
            $(".product-compare-flyout").css("height", "auto");
            if (comparisionList.length < maxItemsToCompare && !itemAlreadyExists) {
                comparisionList.push(currentItem);
                buildCompareList(false);
            }
        });
        $("body").on("click", ".clearAllProducts", function () {
            comparisionList = [];
            $(".product-compare-flyout").css("display", "none");
            $(".product-compare-flyout").css("height", "0px");
            buildCompareList(false);
        });
        $("body").on("click", ".closeMark", function (evt) {

            for (var i = 0; i < comparisionList.length; i++) {
                if (comparisionList[i].id === $(evt.currentTarget).attr("data-product-id")) {
                    comparisionList.splice(i, 1);
                }
            }
            if (comparisionList.length === 0) {
                $(".product-compare-flyout").css("display", "none");
                $(".product-compare-flyout").css("height", "0px");
            }

            buildCompareList(true);
        });
        $("body").on("click", ".compareProducts", function () {
            if (comparisionList.length >= 2) {
                var products = $(".product-compare-container .product-placeholder");
                var productsAdded = [];
                for (var i = 0; i < products.length; i++) {
                    var prodId = $(products[i])[0].id;
                    if (prodId !== "") {
                        productsAdded.push(prodId);
                    }
                }

                var redirectionUrl = $(".product-compare-container").attr("data-compareurl");
                if (redirectionUrl === "") {
                    location.reload();
                    return;
                }
                else {
                    redirectionUrl = redirectionUrl + "?";
                }
               

                for (var j = 0; j < productsAdded.length; j++) {
                    if (j !== 0) {
                        redirectionUrl += "&";
                    }
                    redirectionUrl += "p" + (j + 1) + "={" + productsAdded[j] + "}";
                }
                redirectionUrl += "&ReturnUrl=" + window.location.href;
                window.location.href = encodeURI(redirectionUrl);
            }

        });
        function buildCompareList(isRefresh) {
                    if(isRefresh) $(".product-compare-container").empty();
                    
                    var container = $(".product-compare-container");
                    var placeholders = container.find(".product-placeholder");

                    // Ensure the container has exactly 4 placeholders
                    while (placeholders.length < maxItemsToCompare) {
                        container.append('<div class="product-placeholder col-xs-6 col-md-4 col-lg-3"><div class="non-active"></div></div>');
                        placeholders = container.find(".product-placeholder");
                    }

                    // Update each placeholder based on the comparisionList
                    placeholders.each(function (index) {
                        var $placeholder = $(this);
                        var item = comparisionList[index];

                        if (item) {
                            // Populate the placeholder with product data
                            if (!$placeholder.attr("id")) {
                                $placeholder.html(
                                    '<div class="closeIcon"><span class="closeMark" data-product-id="' + item.id + '">X</span></div>' +
                                    '<a href="' + item.href + '"><img src="' + getProductImage(item.id) + '" /></a>' +
                                    '<div class="product-list-heading">' +
                                    '<h4><a href="' + item.href + '">' + getProductName(item.id) + '</a></h4>' +
                                    '</div>'
                                ).attr("id", item.id).removeClass("non-active");
                            }
                        } else {
                            // Mark the placeholder as non-active if empty
                            $placeholder.html('<div class="non-active"></div>').removeAttr("id");
                        }
                    });

                    // Update the "Compare" button state
                    toggleCompareButton();
                }

                // Utility functions to fetch product details
                function getProductImage(productId) {
                    var img = $("[id='" + productId + "']").find(".product-list-image img").attr("src");
                    return img || "";
                }

                function getProductName(productId) {
                    return $("[id='" + productId + "']").find(".product-list-heading").text() || "";
                }

                // Function to handle enabling/disabling the compare button
                function toggleCompareButton() {
                    var filledSlots = comparisionList.filter(Boolean).length;
                    var compareButton = $(".product-list-btn-container .btn-compare");

                    if (filledSlots >= maxItemsToCompare) {
                        compareButton.addClass("disabled");
                    } else {
                        compareButton.removeClass("disabled");
                    }
        }
        function getMethod(serviceUrl, type, data, successCallback) {
            $.ajax({
                url: serviceUrl,
                type: type,
                data: data,
                success: successCallback,
                error: function (xhr) {
                    //Do Something to handle error
                }
            });
        }
    });

}(window.jQuery));